import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

// Translate
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { CustomDateAdapter, MY_DATE_FORMATS } from '../../../common/utility/CustomDateAdapter';

@Component({
  selector: 'app-add-job-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDatepickerModule,
    TranslatePipe
  ],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
  ],
  templateUrl: './add-job-dialog.component.html',
  styleUrl: './add-job-dialog.component.scss'
})
export class AddJobDialogComponent {
  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    private dialogRef: MatDialogRef<AddJobDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if(this.data.id){
      this.editMode = true;
      
      this.Form = this.fb.group({
        id: [this.data.id],
        person_Id: [this.data.personId],
        company: [this.data.company, Validators.required],
        position: [this.data.position, Validators.required],
        startdate: [this.data.startdate, Validators.required],
        enddate: [this.data.enddate],
        isactive: [true]
      });
    }else{
      this.editMode = false;

      this.Form = this.fb.group({
        id: [0],
        person_Id: [this.data.personId],
        company: ['', Validators.required],
        position: ['', Validators.required],
        startdate: ['', Validators.required],
        enddate: [null],
        isactive: [true]
      });
    }
  }
  editMode: boolean = false;

  Form: FormGroup;

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.Form.valid) {
      this.dialogRef.close(this.Form.value);
    }
  }
}
